import { useMemo } from "react";
import useMapboxAccessToken from "@/use-mapbox-access-token";
import geocoding from "@mapbox/mapbox-sdk/services/geocoding";
export type { GeocodeResponse } from "@mapbox/mapbox-sdk/services/geocoding";

export const useGeocoding = () => {
  const { accessToken } = useMapboxAccessToken();

  const service = useMemo(() => geocoding({ accessToken }), [accessToken]);

  return { service };
};
